
import StockJournalDetails from './StockJournalDetails';

export default StockJournalDetails;


